<template>
	<div class="container-my-debits">
		<template>
			<div class="header-debits">

				<i
					:style="{ color: parceiroConfigCorSecundariaCorPrimaria }"
					class="fas fa-times"
					@click="$router.push({ name: 'AccordionTabs' })" ></i>

			</div>

			<h3 :style="{ color: parceiroConfigCorSecundariaCorPrimaria }">{{ tituloPagina }}</h3>

			<p class="message-sub">{{ temAcordos }}</p>

			<div v-if="parceiroConfig.sessoes.customization.campos.myDebits.textChavePix"
				style="display: flex; flex-direction: column; align-items: center">
				<img src="../../../assets/images/pix-106.svg" style="margin-bottom: 10px" />
				<p class="message-sub">Aceitamos pagamentos por PIX.</p>
				<p class="message-sub">Nossa chave é PIX: {{
					parceiroConfig.sessoes.customization.campos.myDebits.textChavePix }}</p>
			</div>

			<agreement-card
				v-for="acordo in acordos"
				:key="acordo.aco_codigo"
				:acordo="acordo"></agreement-card>

		</template>
	</div>
</template>

<script>
import { mapState, mapMutations, createNamespacedHelpers } from "vuex";
import mixins from "@/mixins/mixins";

import Template from "@/views/admin/Template";
import AgreementCard from "./components/AgreementCard";
import ButtonDefault from "@/components/buttons/ButtonDefault";

const { mapActions: mapActionsPassosRetornarDividas } = createNamespacedHelpers("passosRetornarDividas");

export default {
	name: "MyAgreements",

	components: { AgreementCard, Template, ButtonDefault },

	mixins: [mixins],

	created() {
		this.SET_LOADING(true);
		this.SET_LOADING_MESSAGE("Carregando os seus acordos.");

		this.lojas.forEach(loja => {
			this.acaoPasso5RetornarAcordo({
				lojCodigo: loja.loj_codigo

			}).then(resposta => {
				if (resposta.dados !== null) {
					for (const acordo in resposta.dados.acordos) {
						if (resposta.dados.acordos[acordo].forma_pagamento == 'cartao' && resposta.dados.acordos[acordo].parcelas.length > 1) {
							resposta.dados.acordos[acordo].parcelas = [resposta.dados.acordos[acordo].parcelas[0]];
							resposta.dados.acordos[acordo].parcelas[0].valor = resposta.dados.acordos[acordo].valor_negociado;
						}

						this.acordos.push({
							dadosAcordo: resposta.dados.acordos[acordo],
							loja
						});
					}
				}
			});
		});
	},

	data() {
		return {
			mensagem: "Você ainda não possui acordos.",
			acordos: []
		};
	},

	computed: {
		...mapState({
			empresas: (estado) => estado.empresas,
			lojas: (estado) => estado.passosRetornarDividas.lojas
		}),

		tituloPagina() {
			return this.parceiroConfig.sessoes.customization.campos.myAgreements.textMyAgreements ?
				this.parceiroConfig.sessoes.customization.campos.myAgreements.textMyAgreements : "Meus Acordos";
		},

		mensagemDeQuantidadeDeAcordos() {
			return "Você possui " + this.acordos.length + " " +
				(this.parceiroConfig.sessoes.customization.campos.myAgreements.subtextPanelMyAgreements ?
					this.parceiroConfig.sessoes.customization.campos.myAgreements.subtextPanelMyAgreements : this.acordos.length === 1 ?
						"acordo" : "acordos");
		},

		mensagemSemAcordos() {
			return this.parceiroConfig.sessoes.customization.campos.myAgreements.subtextPanelMyAgreementsNotFound ?
				this.parceiroConfig.sessoes.customization.campos.myAgreements.subtextPanelMyAgreementsNotFound : this.mensagem;
		},

		temAcordos() {
			if (this.acordos.length > 0) {
				return this.mensagemDeQuantidadeDeAcordos;

			} else {
				return this.mensagemSemAcordos;
			}
		}
	},

	beforeMount() {
		this.SET_LOADING(false);
		this.SET_LOADING_MESSAGE('');
	},

	methods: {
		...mapMutations(["SET_ACORDOS", "SET_LOADING", "SET_LOADING_MESSAGE"]),
		...mapActionsPassosRetornarDividas(["acaoPasso5RetornarAcordo"])
	}
};
</script>

<style scoped lang="scss">
.container-my-debits {
	padding: 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
	background: #f3f5f9;
	flex: 1;
	box-sizing: border-box;
}

.header-debits {
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
	box-sizing: border-box;
	width: 100%;
	max-width: 750px;
	cursor: pointer;
}

h3 {
	color: #031b4e;
	font-family: Montserrat-Bold;
	font-size: 28px;
	margin-bottom: 10px;
	text-transform: uppercase;
}

.header-debits i {
	font-size: 48px;
	color: #031b4e;
}

.message-sub {
	color: #5b6987;
	font-size: 14px;
	margin-bottom: 10px;
}
</style>
